/**
 * License Challenge.
 *
 *
 * @beta
 */
export const CHALLENGE = 'Challenge'
